<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">Najčastejšie otázky</h1>
      <span class="is-size-7">
        <p>
          E-mail zákazníckeho servisu: <a class="has-text-primary" href="mailto:keepyoufit.sk@silverlines.info">keepyoufit.sk@silverlines.info</a><br>
          Horúca linka služieb zákazníkom: <a class="has-text-primary" href="tel:0313215999">0313215999</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/SK/Help.vue